import FieldTypesEnum from '../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import IobLineItem from './IobLineItem';

class IobLineItemOutsourcedFte extends IobLineItem {
  static NameOfTheIdField() {
    return 'IoblineItemId';
  }

  static FieldsToShowInDataTable() {
    return [
      { label: 'Id', orderById: 'IoblineItemId', data: 'IoblineItemId', type: FieldTypesEnum.DataFieldWithDetails, minWidth: 70 },
      { label: 'Type', orderById: 'Type', data: 'Type' },
      { label: 'FTE Details', orderById: 'Description', data: 'Description' },
      { label: 'Amount', orderById: 'Amount', data: 'Amount' },
      { label: ' ', orderById: '', data: IobLineItem.getActionsContent, type: FieldTypesEnum.ActionButton, className: 'text-center' },
    ];
  }

  static FieldsToShowInListTable = [
    {
      tabName: 'General',
      tabLabel: 'General',
      icon: 'fa-solid fa-home',
      data: [
        { name: 'IoblineItemId', label: 'Line Item ID' },
        { name: 'Type', label: 'Type' },
        { name: 'FteSummary', label: 'FTE Details' },
        { name: 'Amount', label: 'Amount' },
        { name: 'CurrencyName', label: 'Currency' },
      ],
    },
  ];
}

export default IobLineItemOutsourcedFte;
